import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const audit = {
  gate: (payload) => axios.post(`${API}/audit/gate`, payload).then((r) => r.data),
  verify: (payload) => axios.post(`${API}/audit/verify`, payload).then((r) => r.data),
  resumeRequest: (email) => axios.post(`${API}/audit/resume-request`, { email }).then((r) => r.data),
  state: (token) => axios.get(`${API}/audit/state`, { params: { token } }).then((r) => r.data),
  answer: (token, question_key, answer_value) =>
    axios.post(`${API}/audit/answer`, { token, question_key, answer_value }).then((r) => r.data),
  submit: (token) => axios.post(`${API}/audit/submit`, { token }).then((r) => r.data),
};

const adminHeaders = () => ({ headers: { "x-admin-token": localStorage.getItem("cw_admin_token") || "" } });

export const admin = {
  login: (token) => axios.post(`${API}/admin/login`, { token }).then((r) => r.data),
  dealBoard: () => axios.get(`${API}/admin/deal-board`, adminHeaders()).then((r) => r.data),
  queue: () => axios.get(`${API}/admin/queue`, adminHeaders()).then((r) => r.data),
  release: (report_id) => axios.post(`${API}/admin/release`, { report_id }, adminHeaders()).then((r) => r.data),
  emails: () => axios.get(`${API}/admin/emails`, adminHeaders()).then((r) => r.data),
  analytics: () => axios.get(`${API}/admin/analytics`, adminHeaders()).then((r) => r.data),
  content: (table) => axios.get(`${API}/admin/content/${table}`, adminHeaders()).then((r) => r.data),
  fixtures: () => axios.get(`${API}/admin/fixtures`, adminHeaders()).then((r) => r.data),
  runFixture: (fixture_id, step = "all") =>
    axios.post(`${API}/admin/fixtures/run`, { fixture_id, step }, adminHeaders()).then((r) => r.data),
  runAllFixtures: () =>
    axios.post(`${API}/admin/fixtures/run-all`, {}, { ...adminHeaders(), timeout: 900000 }).then((r) => r.data),
  templateFreeze: () => axios.get(`${API}/admin/template/freeze`, adminHeaders()).then((r) => r.data),
  signTemplate: (signer, template_version = "v1.0") =>
    axios.post(`${API}/admin/template/sign`, { signer, template_version }, { ...adminHeaders(), timeout: 900000 }).then((r) => r.data),
  digestRun: () => axios.post(`${API}/admin/digest/run-now`, {}, adminHeaders()).then((r) => r.data),
  pdfUrl: (report_id) =>
    `${API}/admin/reports/${report_id}/pdf?admin_token=${encodeURIComponent(localStorage.getItem("cw_admin_token") || "")}`,
};
